module.exports = __webpack_public_path__ + "ptc_nakagawa_E1.dfeda9c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_E1.jpg
// module id = N71Z
// module chunks = 0